import { Component, OnInit, TemplateRef, ViewChild, inject, input } from '@angular/core';
import { VersionService } from '@services/version-service/version.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PortfolioIconComponent } from './portfolio-icon/portfolio-icon.component';
import { FeComponentLibraryModule, ThemeModule } from '@wind-log_library/fe-component-library';
import { NgClass } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
  styleUrls: ['./user-box.component.scss'],
  imports: [
    BsDropdownModule,
    TranslateModule,
    PortfolioIconComponent,
    FeComponentLibraryModule,
    ThemeModule,
    NgClass
  ],
})
export class UserBoxComponent implements OnInit {
  @ViewChild('confirmationModal') confirmationModal: TemplateRef<any>;
  smallNav = input(false);
  userName!: string;
  versionInfo!: string;
  userLogo!: string;
  userProfile: any;
  public role!: string;

  private keycloak = inject(Keycloak);
  private versionService = inject(VersionService);
  private dialog = inject(MatDialog);
  private router = inject(Router);

  ngOnInit(): void {
    this.loadUserProfile();
    this.versionInfo = this.versionService.getFormattedVersion();
  }

  async loadUserProfile() {
    this.keycloak.loadUserProfile().then(profile => {
      this.userProfile = profile;
      this.userName = this.userProfile.firstName + ' ' + this.userProfile.lastName;
      const portfolio_rights = this.userProfile.attributes.portfolio_rights;
      const position = this.userProfile.attributes.position?.[0]?.trim() || '';
      this.role = position ? position.charAt(0).toUpperCase() + position.slice(1).toLowerCase() : '';
      if (portfolio_rights) {
        this.userLogo = `${JSON.parse(portfolio_rights[0]).portfolio_id}`;
      }
    });
  }

  openConfirmationModal(): void {
    this.dialog.open(this.confirmationModal, {
      disableClose: true,
      autoFocus: true,
      width: '300px',
    });
  }

  logout(): void {
    this.keycloak.logout({redirectUri: window.location.origin});
  }

  closeConfirmationModal() {
    this.dialog.closeAll();
  }

  goToSettings() {
    const current = this.router.url;

    if (!current.startsWith('/settings')) {
      this.router.navigate(['/settings']);
    }
  }
}
